<template>
    <div>
        <b-button pill class="btn-dark tooltip-cpms" size="sm" :id="id">i</b-button>
        <!--<span class="d-block" :id="id"><font-awesome-icon :icon="['fas', 'info-circle']" /></span>-->
        <b-tooltip :target="id" triggers="hover">
            <span v-html="htmlText"></span>
        </b-tooltip>
    </div>
</template>

<script>
export default {
    props:{
        id:{
            Type:String,
            Required:true
        },
        htmlText:{
            Type:String,
            Required:false
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/InfoTooltip.vue